import { ReactNode, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone, CalendarCheck } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function BookingContactModal({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl tracking-wider text-center">
            BOOK YOUR STAY
          </DialogTitle>
          <DialogDescription className="text-center text-sm">
            Book directly online for our best rates, or contact our reservations team for personalized assistance.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-4 py-4">
          <a
            href="https://booking.roomraccoon.co.za/zwahili-game-lodge/en/"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
            onClick={() => setOpen(false)}
          >
            <Button variant="gold" className="w-full min-h-14 text-sm flex items-center justify-between px-6">
              <span className="flex items-center gap-3">
                <CalendarCheck size={18} />
                Book Online Now
              </span>
              <ArrowRight size={18} />
            </Button>
          </a>

          <div className="relative my-2">
            <div className="absolute inset-0 flex items-center">
              <span className="w-full border-t border-border" />
            </div>
            <div className="relative flex justify-center text-xs uppercase tracking-widest">
              <span className="bg-background px-2 text-muted-foreground">Or Contact Us</span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <a 
              href="tel:+27123620681" 
              className="block"
              onClick={() => setOpen(false)}
            >
              <Button variant="outline" className="w-full h-auto py-3 flex flex-col gap-2">
                <Phone size={16} className="text-gold" />
                <span className="text-xs">+27 12 362 0681</span>
              </Button>
            </a>
            <Link 
              to="/enquire" 
              className="block"
              onClick={() => setOpen(false)}
            >
              <Button variant="outline" className="w-full h-auto py-3 flex flex-col gap-2">
                <Mail size={16} className="text-gold" />
                <span className="text-xs">Enquire via Email</span>
              </Button>
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
